import { PropTypes } from "prop-types"

import ClearButton from "../ClearButton"

export const SelectClearIndicator = props => {
  const { clearValue, innerProps } = props
  return <ClearButton onClick={clearValue} showClearButton {...innerProps} aria-hidden="false" />
}

SelectClearIndicator.propTypes = {
  clearValue: PropTypes.func,
  innerProps: PropTypes.shape({
    onMouseDown: PropTypes.func,
    onTouchEnd: PropTypes.func
  })
}

export default SelectClearIndicator
